import { createStore } from 'vuex'
import data from '/public/data.json'

export default createStore({
  state: {
    data
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
